import { Host } from '@/host'
import { EventBus } from '@/event-bus'
import { ON_MESSAGES, ON_PARTY_CHANGE, ON_PARTY_START, ON_POPUP, ON_TRACK, ON_TRACK_QUEU } from '@/constants/events'

export class Socket {
  host: string
  socket: WebSocket
  pingOpen: boolean = false
  heartbeatInterval = 20000
  token: string
  partyId: number
  errorCount: number = 0
  onError: Function

  constructor(token: string, partyId: number, onError: Function) {
    this.host = new Host().socket
    this.token = token
    this.onError = onError
    this.partyId = partyId
    this.socket = this.createSocket()
  }

  private newSocket() {
    this.socket = this.createSocket()
  }

  private createSocket() {
    this.pingOpen = false
    const socket = new WebSocket(`${this.host}/api/parties/${this.partyId}?access_token=${this.token}`)

    let msgBuf: any[] = []
    let msgTimeout: any = null

    socket.onmessage = (event) => {
      this.errorCount = 0
      if (event.data === 'ping') {
        return
      }

      const eventData = JSON.parse(event.data)

      const chatMessages = eventData.filter((m: any) => m.type === 'message' || m.type === 'poll' || m.type === 'quiz_question' || m.type === 'quiz_scoreboard')
      msgBuf = msgBuf.concat(chatMessages)
      if (msgTimeout === null) {
        msgTimeout = setTimeout(() => {
          if (msgBuf.length > 0) {
            EventBus.$emit(ON_MESSAGES, msgBuf)
          }
          msgBuf = []
          msgTimeout = null
        }, 150)
      }

      for (const msg of eventData) {
        if (msg.type === 'popup') {
          EventBus.$emit(ON_POPUP, msg)
        }

        if (msg.type === 'track_change') {
          EventBus.$emit(ON_TRACK, msg)
        }

        if (msg.type === 'queue_change') {
          EventBus.$emit(ON_TRACK_QUEU, msg)
        }

        if (msg.type === 'party_started') {
          EventBus.$emit(ON_PARTY_START, msg)
        }

        if (msg.type === 'party_changed') {
          EventBus.$emit(ON_PARTY_CHANGE, msg)
        }
      }
    }

    const self = this
    socket.onclose = function (e) {
      console.log('Socket closed', e)
      self.errorCount += 1
      // Code 1008 is authentication error, don't retry
      if (self.errorCount > 5 || e.code === 1008) {
        self.onError()
        return
      }
      const retryTime = self.jitter((0.4 * (2 ** (self.errorCount) - 1)) * 1000)
      console.log('Retry socket in', retryTime, 'ms')

      setTimeout(() => self.newSocket(), retryTime)
    }

    socket.onopen = (e) => this.heartbeat((e.target as WebSocket))
    return socket
  }

  private jitter(value: number): number {
    return value + Math.ceil(Math.random() * 1000)
  }

  private heartbeat(target: WebSocket | null) {
    if (!target || target.readyState !== target.OPEN) {
      return
    }
    // if (this.pingOpen) {
    //   console.log('Ping timeout')
    //   target.close()
    //   return
    // }
    target.send('ping')
    this.pingOpen = true
    setTimeout(() => this.heartbeat(target), this.jitter(this.heartbeatInterval))
  }
}
